export default ({ heading, projectCards }) => {
	return {
		heading,
		projectCards: getProgramList(projectCards),
	};
};

const getProgramList = (projectCards = []) => {
	return projectCards.map(({ gridClass = {}, ...project }) => {
		let bootStrapClass = "";
		const tags = gridClass.tags;
		if (tags && tags.length) {
			tags.forEach(({ text }) => {
				bootStrapClass = `${bootStrapClass} ${text}`;
			});
		}

		return {
			...project,
			gridClass:
				bootStrapClass ||
				"col-xs-12, col-sm-12, col-md-4, col-lg-4, col-xl-4, col-xxl-4",
		};
	});
};
